<template>
  <div class="stationUpsertForm">
    <el-row>
      <el-col :span="11">
        <div class="modal-header">
          <upload field-name="Image" style="width: 100%;" v-model="formData.logoId" :image="formData.logo" />
        </div>
        <div class="input-group">
          <h3>{{ station ? 'Edit' : 'Add' }} station</h3>
          <dg-input type="text" v-model="formData.name" placeholder="Name"/>
          <dg-input type="text" v-model="formData.address" placeholder="Address"/>
          <div class="input-grouped">
            <dg-input type="text" v-model="formData.city" placeholder="City"/>
            <dg-input type="text" v-model="formData.zip" placeholder="Zip"/>
          </div>
          <dg-input type="text" v-model="formData.refId" placeholder="Reference ID"/>

          <div class="split">
            <picker
              placeholder="Organization"
              :api="$api.organizations.index"
              value-key="id"
              v-model="formData.organizationId"
              @pick="getOrganizationCurrency" />
            <picker
              placeholder="Station currency"
              :api="$api.currencies.index"
              value-key="id"
              v-model="formData.currencyId" />
          </div>
          <div class="availability">
             <el-checkbox v-model="formData.public">Public</el-checkbox>
              <el-checkbox v-model="formData.hidden">Hidden</el-checkbox>
          </div>
          <el-button type="primary" size="small" icon="el-icon-upload" @click="handleClick">Save</el-button>
          <p><i class="el-icon-location"></i> Click on the map to place a marker</p>
        </div>
      </el-col>
      <el-col :span="13">
        <station-map :stations="mapStations" height="762px" no-interaction set @setMarker="setCoordinates"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Upload from '@/components/shared/Uploader'
import Picker from '@/components/shared/CollectionPicker'
import StationMap from './map/StationMap'

export default {
  name: 'StationUpsertForm',
  components: { Upload, Picker, StationMap },
  props: {
    station: {
      type: Object
    }
  },
  data () {
    return {
      formData: {
        name: '',
        logoId: '',
        logo: null,
        refId: '',
        locationCoordinates: '',
        organizationId: '',
        currencyId: null,
        address: '',
        zip: '',
        city: '',
        public: false,
        hidden: false,
        statusMessage: '',
        description: ''
      }
    }
  },
  computed: {
    mapStations () {
      if (this.station) {
        return [this.station]
      }

      return []
    }
  },
  methods: {
    setCoordinates (coords) {
      this.formData.locationCoordinates = coords.lat + ',' + coords.lng
    },
    getOrganizationCurrency (organization) {
      this.formData.currencyId = organization.currency.id
    },
    handleClick () {
      if (this.station) {
        this.update().catch(error => { this.$message.error('Station could not be updated, try again.') })
        } else {
        this.add().catch(error =>  { this.$message.error('Station could not be created, try again.') })
      }
    },
    async update () {
      const response = await this.$http.put(this.$api.stations.update(this.station.id), this.formData)
      this.$message.success('Station updated successfully')
      this.$emit('update', response.data)
    },
    async add () {
      const response = await this.$http.post(this.$api.stations.create, this.formData)
      this.$message.success('Station created successfully')
      this.$emit('created', response.data)
    }
  },
  created () {
    if (this.station) {
      this.formData.currencyId = this.station.currency.id
      this.formData.logoId = this.station.logo ? this.station.logo.id : null
      this.formData.organizationId = this.station.organization.id
      for (const key in this.station) {
        this.formData[key] = this.station[key]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .availability {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0px; 
  }

  .split {
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      flex: 1;
    }
  }

  .modal-header {
    background-color: #008fcc;
    padding: 20px 20px;
  }

  .input-group {
    padding: 15px 20px 20px 20px;

    h3 {
      margin-top: 5px;
      margin-bottom: 20px;
      font-size: 14px;
      text-transform: none;
    }

    p {
      text-align: left;
      font-size: 12px;
      margin: 0px;
      color: #909399;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/UpsertForm.vue